import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

export default function NotFound() {
  const { colors } = useTheme();

  return (
    <div
      style={{
        minHeight: '70vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '120px 5vw 80px',
        background: colors.bg,
      }}
    >
      <h1
        style={{
          fontFamily: "'Inter', sans-serif", fontWeight: 800,
          fontSize: 'clamp(3rem, 8vw, 6rem)',
          letterSpacing: '2px',
          color: colors.text,
          marginBottom: '1rem',
        }}
      >
        404
      </h1>
      <p style={{ color: colors.muted, marginBottom: '2rem', fontSize: '1rem' }}>
        This page doesn't exist.
      </p>
      <Link
        to="/"
        style={{
          border: `2px solid ${colors.text}`,
          padding: '0.8rem 2rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          letterSpacing: '1px',
          textTransform: 'uppercase',
          color: colors.text,
        }}
      >
        Back to Home
      </Link>
    </div>
  );
}
